import styled, { css } from 'styled-components'
import tinycolor from 'tinycolor2'
import type { ComponentsTheme } from '../../../providers/ComponentsThemeProvider'
import { getAutomatedStyleProp } from '../../../providers/ComponentsThemeProvider'

const getOutlineColor = ({ theme }: { theme: ComponentsTheme }) => {
  if (theme.automated?.styles?.colorPrimary) {
    return tinycolor(theme.automated?.styles.colorPrimary).setAlpha(0.4).toString()
  }

  return 'var(--border-brand)'
}

export const Container = styled.div<{
  $size: 'small' | 'medium' | 'large'
}>`
  align-self: flex-start;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${getAutomatedStyleProp('colorBackground', 'var(--bg-primary)')};
  border: 1px solid ${getAutomatedStyleProp('inputBorder', 'var(--input-border)')};
  color: transparent;
  border-radius: ${getAutomatedStyleProp('inputCornerRadius', 'var(--radius-brand)')};

  ${({ $size }) =>
    $size === 'small' &&
    css`
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
    `}

  ${({ $size }) =>
    $size === 'medium' &&
    css`
      width: 24px;
      min-width: 24px;
      height: 24px;
      min-height: 24px;
    `}

  ${({ $size }) =>
    $size === 'large' &&
    css`
      width: 32px;
      min-width: 32px;
      height: 32px;
      min-height: 32px;
    `}

  &:hover {
    border: 1px solid ${getAutomatedStyleProp('paleTextColor', 'var(--input-border-hover)')};
  }

  input:checked + & {
    background: ${getAutomatedStyleProp('colorPrimary', 'var(--bg-brand)')};
    border-color: ${getAutomatedStyleProp('colorPrimary', 'var(--bg-brand)')};
    color: ${getAutomatedStyleProp('colorOnPrimary', 'var(--text-on-brand)')};
  }

  input:disabled + & {
    cursor: not-allowed;
    background: var(--bg-tertiary);
    border-color: var(--border-secondary);
  }

  input:checked:disabled + & {
    background: var(--bg-tertiary);
    color: var(--border-secondary);
  }

  input:focus-visible + & {
    outline: 1px solid ${getOutlineColor};
    outline-offset: 2px;
  }

  input:indeterminate + & {
    background: ${getAutomatedStyleProp('colorPrimary', 'var(--bg-brand)')};
    border-color: ${getAutomatedStyleProp('colorPrimary', 'var(--bg-brand)')};
    color: ${getAutomatedStyleProp('colorOnPrimary', 'var(--text-on-brand)')};
  }
`
